// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"54997606","203":"1f11a9bd","372":"ace7728d","451":"96cb354e","453":"0fff3918","922":"49abb019","927":"ea594338"}[chunkId] + ".chunk.js";
};